import TextField from '@mui/material/TextField'
import { omit } from 'lodash'
import * as React from 'react'
import { IMaskInput } from 'react-imask'

// Definições customizadas para a máscara.
// "F" representa um caractere hexadecimal (0-9, a-f, A-F)
const definitions = {
  F: /[0-9a-fA-F]/,
}

type TextMaskCustomProps = {
  lazy?: boolean
  mask: any
  placeholderChar?: string
  uppercase?: boolean
  handleChange?: (value: string) => void
  [key: string]: any
}

const TextMaskCustom = React.forwardRef<HTMLInputElement, TextMaskCustomProps>(
  function TextMaskCustom(props, ref) {
    const { handleChange, lazy, mask, placeholderChar, uppercase, ...other } = props

    // Função executada antes de inserir o valor
    // Utilizada para converter para maiúsculo quando necessário
    const prepare = React.useCallback(
      (val: string) => (uppercase ? val.toUpperCase() : val),
      [uppercase],
    )

    return (
      <IMaskInput
        {...other}
        lazy={lazy}
        mask={mask}
        definitions={definitions}
        inputRef={ref}
        prepare={prepare}
        onAccept={handleChange}
        placeholderChar={placeholderChar}
        overwrite
      />
    )
  },
)

export default function InputMask(props) {
  const {
    error,
    lazy,
    mask,
    onChange,
    placeholderChar = '_',
    required,
    unmask,
    uppercase,
    ...rest
  } = props

  const hasError = Boolean(error)

  const handleChange = React.useCallback(
    (value, mask) => {
      // // Evita disparar onChange se valor não mudou
      if (String(props.value ?? '') === value) return

      if (onChange) onChange(unmask ? mask.unmaskedValue : value)
    },
    [onChange, unmask],
  )

  return (
    <TextField
      // Removemos a prop "ref" pois acaba ocultando o placeholder da mascara.
      {...omit(rest, ['ref'])}
      fullWidth
      variant="standard"
      type="text"
      error={hasError}
      helperText={error || ''}
      slotProps={{
        htmlInput: { handleChange, lazy, mask, placeholderChar, unmask, uppercase } as any,
        input: {
          // Componente customizado de máscara
          inputComponent: TextMaskCustom as any,
        },
        inputLabel: { required, shrink: true },
      }}
    />
  )
}
